import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  ModalFooter,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import TextTruncate from "react-text-truncate";
import Select from "react-select";
import NumberInput from "components/NumberInput";
import Center from "react-center";

export default function ModalSelected(props) {
  const {
    open,
    setOpen,
    data,
    setData,
    kepada,
    selectorAccount,
    loadingAccount,
    selectorCostCenter,
    selectorKompilator,
    loadingKompilatorDanCC,
    handleDone,
    handleClear,
  } = props;
  const dispatch = useDispatch();
  const [selectorJenisJurnal] = useState([
    { value: "D", label: "Debit" },
    { value: "K", label: "Kredit" },
  ]);
  const [jenisJurnal, setJenisJurnal] = useState(null);

  useEffect(() => {
    if (open) {
      if (Number(data[0]?.D) === 0 && Number(data[0]?.K) !== 0) {
        setJenisJurnal("K");
      } else if (Number(data[0]?.D) !== 0 && Number(data[0]?.K) === 0) {
        setJenisJurnal("D");
      } else {
        setJenisJurnal(null);
      }
    } else {
      setJenisJurnal(null);
    }
  }, [open]);

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(false)}
      className="modal-dialog-centered modal-lg"
      backdrop="static"
    >
      <ModalHeader toggle={() => setOpen(false)}></ModalHeader>
      <ModalBody>
        <>
          <FormGroup>
            <Label>Jenis</Label>
            <Select
              styles={{
                color: "black",
              }}
              id="jenis"
              name="jenis"
              options={selectorJenisJurnal}
              value={selectorJenisJurnal?.find(
                (find) => find.value === jenisJurnal
              )}
              onChange={(e) => {
                let tempEdit = data;
                tempEdit[0] = {
                  ...data[0],
                  D: 0,
                  K: 0,
                };
                setData([...tempEdit]);
                setJenisJurnal(e.value);
              }}
            />
          </FormGroup>
          <hr />
          <FormGroup>
            <Label>Keterangan</Label>
            <Input
              type="textarea"
              rows="2"
              id="KET"
              name="KET"
              value={data[0]?.KET}
              onChange={(e) => {
                let tempEdit = data;
                tempEdit[0] = {
                  ...data[0],
                  KET: e.target.value,
                };
                setData([...tempEdit]);
              }}
            />
          </FormGroup>
          <Row>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Rekening</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="AKUN"
                  name="AKUN"
                  options={selectorAccount}
                  value={selectorAccount?.find(
                    (find) => find.value === data[0]?.AKUN
                  )}
                  isLoading={loadingAccount}
                  onChange={(e) => {
                    let tempEdit = data;
                    tempEdit[0] = {
                      ...data[0],
                      AKUN: e.value,
                    };
                    setData([...tempEdit]);
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label>Kompilator</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="KOMP"
                  name="KOMP"
                  options={selectorKompilator}
                  value={selectorKompilator?.find(
                    (find) => find.value === data[0]?.KOMP
                  )}
                  isLoading={loadingKompilatorDanCC}
                  onChange={(e) => {
                    let tempEdit = data;
                    tempEdit[0] = {
                      ...data[0],
                      KOMP: e.value,
                    };
                    setData([...tempEdit]);
                  }}
                />
              </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Cost Center</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="CC"
                  name="CC"
                  options={selectorCostCenter}
                  value={selectorCostCenter?.find(
                    (find) => find.value === data[0]?.CC
                  )}
                  isLoading={loadingKompilatorDanCC}
                  onChange={(e) => {
                    let tempEdit = data;
                    tempEdit[0] = {
                      ...data[0],
                      CC: e.value,
                    };
                    setData([...tempEdit]);
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label>Aktivitas</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="AKT"
                  name="AKT"
                  options={selectorAccount}
                  value={selectorAccount?.find(
                    (find) => find.value === data[0]?.AKT
                  )}
                  isLoading={loadingAccount}
                  onChange={(e) => {
                    let tempEdit = data;
                    tempEdit[0] = {
                      ...data[0],
                      AKT: e.value,
                    };
                    setData([...tempEdit]);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Jumlah</Label>
            <NumberInput
              name="K"
              id="K"
              // decimal
              value={
                jenisJurnal === "K"
                  ? data[0]?.K
                  : jenisJurnal === "D"
                  ? data[0]?.D
                  : ""
              }
              onChange={(e) => {
                let tempEdit = data;
                if (jenisJurnal === "K") {
                  tempEdit[0] = {
                    ...data[0],
                    K: e.target.value,
                  };
                } else if (jenisJurnal === "D") {
                  tempEdit[0] = {
                    ...data[0],
                    D: e.target.value,
                  };
                } else {
                  tempEdit[0] = {
                    ...data[0],
                    D: 0,
                    K: 0,
                  };
                }
                setData([...tempEdit]);
              }}
            />
          </FormGroup>
        </>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {
            handleClear();
          }}
        >
          Hapus
        </Button>
        <Button
          color="primary"
          onClick={() => {
            handleDone();
          }}
          disabled={jenisJurnal !== "D" && jenisJurnal !== "K"}
        >
          Tambahkan
        </Button>
      </ModalFooter>
    </Modal>
  );
}
